import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'antd';
import { TagsFilled } from '@ant-design/icons';
import TableSelect from 'components/TableSelect';
import TooltipHelp from 'components/Tooltip/tooltipHelp';
import Titulo from 'components/Titulo';
import { calcularMb, convertBase64, downloadFileBase64 } from 'utils/arquivo';
import { MSG_TOOLTIP_TAMANHO_ARQUIVO } from 'utils/consts';
import * as STable from 'components/TableSelect/styles';
import * as Style from 'components/Style';
import * as S from '../styles';
import { handleAddItemGrid, handleRemoverItemGrid } from './FormServicoDuvida';
import EditorTextoExibir from 'components/EditorTexto/exibir';
import { useSelector } from 'react-redux';

export default function SolicitacaoArquivos({ salvarAquivos, disabled, documentos, servicoSelecionado, erroArquivos }) {
  const inputDados = useSelector(state => state.inputs.inputDadosRequerimentoCompleto);
  const changeLibras = useSelector(state => state.app.changeLibras);

  const [dadosGrid, setDadosGrid] = useState(inputDados?.arquivos?.arquivosGrid || []);
  const [arquivosAdicionados, setArquivosAdicionados] = useState(inputDados?.arquivos?.arquivos || []);
  const [tamanhoTotalArquivos, setTamanhoTotalArquivos] = useState('0.00 MB');

  React.useEffect(() => {
    const { soma } = calcularMb(0, dadosGrid, 10);
    setTamanhoTotalArquivos(`${soma.toFixed(2)} MB`);
  }, [dadosGrid]);

  async function clickLinhaGrid(rowCompleta) {
    // AO CLICAR NO NOME DO ARQUIVO, TRANSFORMA O MESMO EM BASE64 E EXIBE EM OUTRA GUIA DO NAVEGADOR
    const fileOpen = arquivosAdicionados.find(file => file.key === rowCompleta.key);
    const base64 = await convertBase64(fileOpen);
    downloadFileBase64(base64);
  }

  const columns = [
    {
      title: 'Nome do Arquivo',
      dataIndex: 'nomeArquivo',
      render: (nomeArquivo, rowCompleta) => {
        if (rowCompleta.key.startsWith('TOTALIZADOR_TEMP') === true) return <p>{nomeArquivo}</p>;
        return <STable.OpenLife onClick={() => clickLinhaGrid(rowCompleta)}>{nomeArquivo}</STable.OpenLife>;
      },
      disabled: true,
    },
    {
      title: 'Tamanho do Arquivo',
      dataIndex: 'tamanhoArquivo',
      render: text => <p>{text} MB</p>,
    },
    {
      title: 'Data',
      dataIndex: 'data',
    },
  ];

  const addItemGrid = file => {
    handleAddItemGrid(
      file,
      dadosGrid,
      arquivosAdicionados,
      setArquivosAdicionados,
      setDadosGrid,
      setTamanhoTotalArquivos,
      salvarAquivos
    );
  };

  const removerItemGrid = itensSelecionados => {
    handleRemoverItemGrid(
      itensSelecionados,
      dadosGrid,
      arquivosAdicionados,
      setDadosGrid,
      setArquivosAdicionados,
      salvarAquivos,
      setTamanhoTotalArquivos
    );
  };

  return (
    <>
      <S.tituloGrid>
        {servicoSelecionado?.nome && (
          <>
            <Titulo textTitle={`Serviço: ${servicoSelecionado?.nome}`} />
            {servicoSelecionado?.descricao && (
              <S.DescricaoServico>
                <Row align="middle" className="cardRow">
                  <TagsFilled />
                  <p>{servicoSelecionado?.descricao} </p>
                  <br />
                </Row>
              </S.DescricaoServico>
            )}
          </>
        )}
        <Titulo textTitle={'Anexos'} />
        {erroArquivos && <Style.GlobalErro>{erroArquivos}</Style.GlobalErro>}
        <S.fraseArquivo>
          Se necessário preencha a tabela com os anexos pertinentes ao assunto solicitado. Os arquivos devem ser no
          formato PDF.
        </S.fraseArquivo>
        {<EditorTextoExibir mensagemHtml={documentos} border={false} />}
      </S.tituloGrid>
      <TableSelect
        columns={columns}
        data={dadosGrid}
        funcAdd={addItemGrid}
        funcDelete={removerItemGrid}
        disabled={disabled}
      />
      <S.ContainTamanhoArq data-testid="total-arquivos" style={{ display: changeLibras ? 'none' : 'block' }}>
        <Row>
          <p>
            Tamanho total dos arquivos: <b>{tamanhoTotalArquivos}</b>&nbsp;
          </p>
          <TooltipHelp text={MSG_TOOLTIP_TAMANHO_ARQUIVO} />
        </Row>
      </S.ContainTamanhoArq>
    </>
  );
}

SolicitacaoArquivos.propTypes = {
  salvarAquivos: PropTypes.func,
  disabled: PropTypes.bool,
  erroArquivos: PropTypes.string,
};
